/**
 * 데이터 포맷팅 유틸리티 함수
 * 작업자: 젠이츠
 */

/**
 * 숫자를 쉼표가 포함된 문자열로 포맷팅
 * @param {number|string} value - 포맷팅할 값
 * @returns {string} 포맷팅된 문자열
 */
export function formatNumWithComma(value) {
    let formatValue;

    if (!isNaN(value)) {
        formatValue = typeof value == "number" ? value._comma() : Number(value)._comma();
    } else {
        formatValue = value;
    }
    return formatValue;
}

/**
 * 날짜를 지정된 형식으로 포맷팅
 * @param {Date|string} date - 날짜
 * @param {string} format - 포맷 형식 (YYYY-MM-DD 등)
 * @returns {string} 포맷팅된 날짜 문자열
 */
export function formatDate(date, format = "YYYY-MM-DD") {
    if (!date) return "";
    const moment = require("moment");
    return moment(date).format(format);
}
